import React, { Component } from 'react';
import { compose } from 'recompose';
import Moment from 'react-moment';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import cellEditFactory from 'react-bootstrap-table2-editor'; 
import { Button, Form, Container, Image } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';

import { withFirebase } from '../Firebase';
import { AuthUserContext, withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';
import * as ROUTES from '../../constants/routes';

const dateToFormat = new Date(); // e.g. Mon Apr 19 1976 09:59:00 GMT-0800
const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const INITIAL_STATE = {
  faultID: '',
  faultOwner: '',
  faultOwnerName: '',
  faultDescription: '',
  faultCategory: '',
  faultOutlet: '',
  updates: '',
  selectedRowIndex: '',

  feedbackID: '',
  feedbackCustomerName: '',
  feedbackCustomerEmail: '',
  feedbackOutlet: '',
  feedbackDescription: '',
  selectedRowIndexFeedback: '',

  isResolved: false,
  selectedRowIndexResolvedReport: '',
};

const pagination = paginationFactory({
  sizePerPageList:[
    {
      text:'5', value:5
  }, {
      text:'10', value:10
  } ]
});

const columns = [{
  dataField: 'faultID',
  hidden: true,
  text: '# id',
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date & Time',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultCategory',
  text: 'Category',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultDescription',
  text: 'Description',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultStatus',
  text: 'Status',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'isAssigned',
  text: 'isAssigned',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'assignedAdminUid',
  text: 'assignedAdminUid',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'assignedAdminName',
  text: 'assignedAdminName',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'updates',
  text: 'updates',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOwner',
  text: 'faultOwner',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOwnerName',
  text: 'faultOwnerName',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}];

const columnsResolved = [{
  dataField: 'faultID',
  text: '# id',
  hidden: true,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date & Time',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultCategory',
  text: 'Category',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultDescription',
  text: 'Description',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultStatus',
  text: 'Status',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'isAssigned',
  text: 'isAssigned',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'assignedAdminUid',
  text: 'assignedAdminUid',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'assignedAdminName',
  text: 'assignedAdminName',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'updates',
  text: 'updates',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOwner',
  text: 'faultOwner',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'faultOwnerName',
  text: 'faultOwnerName',
  hidden: true,
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}];

const columnsFeedback = [{
  dataField: 'feedbackID',
  hidden: true, 
  text: '# id',
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'dateSubmitted',
  text: 'Date & Time',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'feedbackCustomerName',
  text: 'Name',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'},
}, {
  dataField: 'feedbackOutlet',
  text: 'Outlet',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'}
}, {
  dataField: 'feedbackDescription',
  text: 'Description',
  editable: false,
  headerStyle: { backgroundColor: '#491514', color: 'white'}
}];

class AdminHomePage extends Component {
  constructor(props) {
    super(props);
 
    this.state = { 
      ...INITIAL_STATE,
      loading: false,
      faultReportsArray: [],
      feedbackArray: [],
      resolvedReportsArray: [],
    };
  }
  
  componentDidMount() {
    this.setState({ loading: true });
 
    this.props.firebase.users().on('value', snapshot => {
      const usersObject = snapshot.val();

      const usersList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));

      var faultNewIDCount = 0;
      var resolvedFaultNewIDCount = 0;
      var feedbackNewIDCount = 0;
      var tempFaultReportsArray = [];
      var tempResolvedReportsArray = [];
      var tempFeedbackArray = [];
      for (var i=0; i<usersList.length; i++) {
        if (usersList[i].roles.hasOwnProperty("USER")) {
          if (usersList[i].hasOwnProperty("faultReports")) {
            for (var j=0; j<usersList[i].faultReports.length; j++) {
              usersList[i].faultReports[j].faultID = faultNewIDCount;
              usersList[i].faultReports[j].faultOwner = usersList[i].uid;
              usersList[i].faultReports[j].faultOwnerName = usersList[i].username;
              faultNewIDCount++;
              tempFaultReportsArray.push(usersList[i].faultReports[j]);
            }
          }
          if (usersList[i].hasOwnProperty("resolvedReports")) {
            for (var j=0; j<usersList[i].resolvedReports.length; j++) {
              usersList[i].resolvedReports[j].faultID = resolvedFaultNewIDCount;
              usersList[i].resolvedReports[j].faultOwner = usersList[i].uid;
              usersList[i].resolvedReports[j].faultOwnerName = usersList[i].username;
              resolvedFaultNewIDCount++;
              tempResolvedReportsArray.push(usersList[i].resolvedReports[j]);
            }
          }
          if (usersList[i].hasOwnProperty("feedback")) {
            for (var k=0; k<usersList[i].feedback.length; k++) {
              usersList[i].feedback[k].feedbackID = feedbackNewIDCount;
              feedbackNewIDCount++;
              tempFeedbackArray.push(usersList[i].feedback[k]);
            }
          }
        }
      }

      console.log("Fault Report Array: ", tempFaultReportsArray);
      console.log("Resolved Report Array: ", tempResolvedReportsArray);
      console.log("Feedback Array", tempFeedbackArray);
      console.log("UserList", usersList);
      
      this.setState({
        loading: false,
        faultReportsArray: tempFaultReportsArray,
        resolvedReportsArray: tempResolvedReportsArray,
        feedbackArray: tempFeedbackArray,
      });
    });
  }

  // Remove the listener to avoid memory leaks
  componentWillUnmount() {
    this.props.firebase.users().off();
  }
 
  writeData = (row) => {
    this.props.firebase.doUpdateSelectedFaultReport(row.faultID, row.faultCategory, row.faultDescription, row.faultOutlet, row.faultStatus);
  };

  viewSelectedReport = (selectedRowIndex) => {
    console.log("View Report for Row Index: ", selectedRowIndex);
    this.setState({selectedRowIndex:selectedRowIndex});
    if (selectedRowIndex === '') { // no report selected
      window.alert("No report selected. Please select a report from the table to view.");
    }
    else {
      this.props.history.push({
        pathname: ROUTES.REPORT_DETAILS,
        state: { faultReport : this.state.faultReportsArray[selectedRowIndex] }
      })
    }
  };

  viewSelectedResolvedReport = (selectedRowIndexResolvedReport) => {
    console.log("View Report for Row Index: ", selectedRowIndexResolvedReport);
    this.setState({selectedRowIndexResolvedReport:selectedRowIndexResolvedReport});
    if (selectedRowIndexResolvedReport === '') { // no report selected
      window.alert("No report selected. Please select a report from the table to view.");
    }
    else {
      this.props.history.push({
        pathname: ROUTES.REPORT_DETAILS,
        state: { faultReport : this.state.resolvedReportsArray[selectedRowIndexResolvedReport] }
      })
    }
  };

  assignReport = (selectedRowIndex, faultOwner, faultCategory, faultDescription, faultOutlet) => {
    console.log("Assigning Report for Row Index: ", selectedRowIndex);
    this.setState({selectedRowIndex:selectedRowIndex});
    if (selectedRowIndex === '') { // no report selected
      window.alert("No report selected. Please select a report from the table to view.");
    }
    else {
      this.props.firebase.doAssignSelectedFaultReport(faultOwner, faultCategory, faultDescription, faultOutlet);
    }
  };

  deleteReport = (selectedRowIndex, faultOwner, faultCategory, faultDescription, faultOutlet) => {
    console.log("Deleting Report for Row Index: ", selectedRowIndex);
    this.setState({selectedRowIndex:selectedRowIndex});
    if (selectedRowIndex === '') { // no feedback selected
      window.alert("No report selected. Please select a report from the table to delete.");
    }
    else {
      this.props.firebase.doDeleteReport(faultOwner, faultCategory, faultDescription, faultOutlet);
      window.location.reload(false);
    }
  };

  viewSelectedFeedback = (selectedRowIndexFeedback) => {
    console.log("View Feedback for Row Index: ", selectedRowIndexFeedback);
    this.setState({selectedRowIndexFeedback:selectedRowIndexFeedback});
    if (selectedRowIndexFeedback === '') { // no feedback selected
      window.alert("No feedback selected. Please select a feedback from the table to view.");
    }
    else {
      this.props.history.push({
        pathname: ROUTES.FEEDBACK_DETAILS,
        state: { feedback : this.state.feedbackArray[selectedRowIndexFeedback] }
      })    
    }
  };

  deleteSelectedFeedback = (selectedRowIndexFeedback, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet) => {
    console.log("Deleting Feedback for Row Index: ", selectedRowIndexFeedback);
    this.setState({selectedRowIndexFeedback:selectedRowIndexFeedback});
    if (selectedRowIndexFeedback === '') { // no feedback selected
      window.alert("No feedback selected. Please select a feedback from the table to delete.");
    }
    else {
      this.props.history.push(ROUTES.ADMIN_HOME);
      this.props.firebase.doDeleteFeedback(feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet);
      window.location.reload(false);
    }
  };

  updateSelectedFaultReport = (updates, faultOwner, faultCategory, faultDescription, faultOutlet) => {
    this.props.firebase.doUpdateSelectedFaultReportByAdmin(this.state.isResolved, updates, faultOwner, faultCategory, faultDescription, faultOutlet);
    this.setState({ updates : '', isResolved : false });
    //window.location.reload(false);
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
 
  onChangeCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    var { faultOwner, faultOutlet, faultCategory, faultDescription, updates, isResolved } = this.state;
    var { feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet } = this.state;
    const { faultReportsArray, resolvedReportsArray, feedbackArray } = this.state;

    const isInvalidUpdate = updates === '';

    var selectedRowIndex = '';
    var selectedRowIndexFeedback = '';
    var selectedRowIndexResolvedReport = '';

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.faultID);
        selectedRowIndex = row.faultID;
        //faultOwnerName = faultReportsArray[rowIndex].faultOwnerName;
        faultOwner = faultReportsArray[selectedRowIndex].faultOwner;
        //faultCategory = faultReportsArray[rowIndex].faultCategory;
        faultDescription = faultReportsArray[selectedRowIndex].faultDescription;
        //faultOutlet = faultReportsArray[rowIndex].faultOutlet;
        console.log(faultOwner + " " + faultDescription);
      }
    };

    const selectRowFeedback = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.feedbackID);
        selectedRowIndexFeedback = row.feedbackID;
        feedbackCustomerName = feedbackArray[selectedRowIndexFeedback].feedbackCustomerName;
        feedbackCustomerEmail = feedbackArray[selectedRowIndexFeedback].feedbackCustomerEmail;
        feedbackDescription = feedbackArray[selectedRowIndexFeedback].feedbackDescription;
        feedbackOutlet = feedbackArray[selectedRowIndexFeedback].feedbackOutlet;
        console.log(feedbackCustomerName);
      }
    };

    const selectRowResolvedReport = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: '#491514',
      onSelect: (row, isSelect, rowIndex, e) => {
        console.log("Selected Table Row Index: ", row.faultID);
        selectedRowIndexResolvedReport = row.faultID;
      }
    };

    const MyExportCSV = (props) => {
      const handleClick = () => {
        props.onExport();
      };
      return (
        <div>
          <button class="btn btn-success" floated='right' onClick={ handleClick }>Export to Excel</button>
        </div>
      );
    };
    
    return (
      <AuthUserContext.Consumer>
      {authUser => (
        <Container>
          <hr />
          <Container>
          <div class="ui inverted fluid segment">
          <Image src='\Images\bch_logo_small.png' size='small' floated='right' />
          <Moment format="dddd, D MMM YYYY, hh:mm:ss a" date={dateToFormat} />
          <h1>Welcome {authUser.username}</h1>
          <div class="customFontSmall">Email: {authUser.email}</div>
          <div class="customFontSmall">Contact Number: {authUser.contactNumber}</div>

          {!!authUser.isNewUser === false && !!authUser.roles[ROLES.USER] && (
          <div class="customFontSmall">Role: Store Associate</div>
          )}

          {!!authUser.isNewUser === false && !!authUser.roles[ROLES.ADMIN] && (
          <div class="customFontSmall">Level: Admin</div>
          )}

          {!!authUser.isNewUser === true && (
          <div class="customFontSmall">Role: Store Associate (please reset your password)</div>
          )}
          <p></p>
          </div>
          </Container>

          <Container>
          <Tabs>
            <TabList style={{ backgroundColor:'black', textAlign:'center'}}>
            <Tab>Fault</Tab>
            <Tab>Feedback</Tab>
            <Tab>Resolved</Tab>
            </TabList>

            <TabPanel>
              <p></p>
              <div class="ui inverted fluid segment">
              <ToolkitProvider
                keyField="faultID"
                data={ faultReportsArray }
                columns={ columns }
                striped
                hover
                condensed
                exportCSV
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRow }
                                        pagination={pagination}
                                        />
                        <Button floated='left' color="green" size="small" type="click" onClick={()=>{this.viewSelectedReport(selectedRowIndex);}}>View</Button>
                        <ExportCSVButton { ...props.csvProps }>Export Excel</ExportCSVButton>
                        <p></p>
                        <div class="customFontSmall">Total number of Fault Reports: { faultReportsArray.length }</div>
                        </div>
                    )
                  }
              </ToolkitProvider>
              </div>
            </TabPanel>

            <TabPanel>
              <p></p>
              <div class="ui inverted segment">
              <ToolkitProvider
                keyField="feedbackID"
                data={ feedbackArray }
                columns={ columnsFeedback }
                striped
                hover
                condensed
                exportCSV
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRowFeedback }
                                        pagination={pagination}
                                        />
                        <Button floated='right' color="red" size="small" type="click" 
                          onClick={()=>{this.deleteSelectedFeedback(selectedRowIndexFeedback, 
                              feedbackCustomerName,
                              feedbackCustomerEmail,
                              feedbackDescription,
                              feedbackOutlet);}}>Delete</Button>
                        <Button floated='left' color="green" size="small" type="click" onClick={()=>{this.viewSelectedFeedback(selectedRowIndexFeedback);}}>View</Button>
                        <ExportCSVButton { ...props.csvProps }>Export Excel</ExportCSVButton>
                        <p></p>
                        <div class="customFontSmall">Total number of Feedback: { feedbackArray.length }</div>
                      </div>
                    )
                  }
              </ToolkitProvider>
              </div>
            </TabPanel>

            <TabPanel>
              <p></p>
              <div class="ui inverted segment">
              <ToolkitProvider
                keyField="faultID"
                data={ resolvedReportsArray }
                columns={ columnsResolved }
                striped
                hover
                condensed
                exportCSV
                search
              >
                  {
                    props => (
                      <div>
                        <SearchBar { ...props.searchProps } />
                        <BootstrapTable { ...props.baseProps } 
                                        selectRow={ selectRowResolvedReport }
                                        pagination= { pagination }
                                        />

                        <Button floated='left' color="green" size="small" type="click" onClick={()=>{this.viewSelectedResolvedReport(selectedRowIndexResolvedReport);}}>View</Button>
                        <ExportCSVButton { ...props.csvProps }>Export Excel</ExportCSVButton>
                        <p></p>
                        <div class="customFontSmall">Total number of Resolved Reports: { resolvedReportsArray.length }</div>
                      </div>
                    )
                  }
              </ToolkitProvider>
              </div>
            </TabPanel>
          </Tabs>
          </Container>
        </Container>
      )}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = authUser => authUser && !!authUser.roles[ROLES.ADMIN];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(AdminHomePage);